import React, { useEffect, useState } from 'react';
import './MarketMayhemScreen.scss'
import RefreshButton from '../../atoms/RefreshButton/RefreshButton';
import { getAllShowDown } from '../../../redux/Slices/ShowDownSlice';
import { AppDispatch } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { selectGameId, selectRoleJoinId } from '../../../redux/Slices/JoinGameSlice';
import Button from '../../atoms/Button/Button';
import BackButton from '../../atoms/BackButton/BackButton';
import { useNavigate } from 'react-router-dom';
import SelectInput from '../../atoms/SelectInput/SelectInput';
import { percentageMayhem } from '../../../app/utils/constants/Options';
import { getAllStock, selectAllStock } from '../../../redux/Slices/StockSlice';
import { message, Select } from 'antd';
import { AveragreMarketMayhem, CreateMarketMayhem, getMarketMayhem, RespondMarketMayhem, selectMarketMayhem, selectMarketMayhemError, selectmarketMayhemId, selectMarketMayhemStatus } from '../../../redux/Slices/MarketMayhemSlice';
import Loader from '../../atoms/Loader/Loader';
import { selectRoleId } from '../../../redux/Slices/SelectRoleSlice';
import Input from '../../atoms/Input/Input';
import { IoChevronBackSharp } from 'react-icons/io5';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import { IoCheckmark, IoClose } from 'react-icons/io5';
import { getLobby, selectAllLobby } from '../../../redux/Slices/lobbySlice';
import getAvatarUrl from '../../../app/utils/common/function';
import { selectGetUser } from '../../../redux/Slices/authSlice';
import { image } from '../../../app/utils/common/image';
const { Option } = Select;

const MarketMayhemScreen = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedCompanies, setSelectedCompanies] = useState<number[]>([]);
    const [selectedPercentages, setSelectedPercentages] = useState<number[]>([]);
    const [selectedInvesCompanies, setSelectedInvesCompanies] = useState<any>(null);
    const [selectedInvesPercentages, setSelectedInvesPercentages] = useState<any>(null);
    const [selectedEntries, setSelectedEntries] = useState<any[]>([]);
    const [showAvg, setShowAvg] = useState<boolean>(false)
    const [invesBrokerResponse, setInvesBrokerResponse] = useState<boolean>(false)
    const [investorBrokerSubmitted, setInvestorBrokerSubmitted] = useState<boolean>(false);
    const [showPlayersOnly, setShowPlayersOnly] = useState<boolean>(false);
    const [percentageOpen, setPercentageOpen] = useState(false);
    const [companyOpen, setCompanyOpen] = useState(false);
    const dispatch: AppDispatch = useDispatch();
    const gameId = useSelector(selectGameId);
    const navigate = useNavigate()
    const allStocks = useSelector(selectAllStock);
    const marketStatus = useSelector(selectMarketMayhemStatus);
    const marketError = useSelector(selectMarketMayhemError);
    const getMarket = useSelector(selectMarketMayhem)
    const marketMayhemId = useSelector(selectmarketMayhemId);
    const roleId = useSelector(selectRoleId);
    const joinRoleId = useSelector(selectRoleJoinId);
    const lobbyPlayers = useSelector(selectAllLobby)?.game_players_data || [];
    const currentUser = useSelector(selectGetUser);
    const roleIdStock = joinRoleId !== undefined ? joinRoleId : roleId;

    useEffect(() => {
        if (marketStatus === 'succeeded') {
            setLoading(false);
        } else if (marketStatus === 'loading') {
            setLoading(true);
        } else if (marketStatus === 'failed') {
            setLoading(false);
            if (marketError?.error?.message === 'Game already completed.') {
                navigate('/profile')
            }
        }
    }, [marketStatus]);

    const handleBackButton = () => {
        navigate('/stock-prices')
    }

    useEffect(() => {
        dispatch(getAllStock(gameId));
        dispatch(getLobby(gameId));
        dispatch(getMarketMayhem(gameId)).unwrap().then((response) => {
            if (response?.data?.stock_ids?.length > 0) {
                setShowAvg(true)
            }
        }).catch((error) => {
            console.log('error', error)
        })
    }, [dispatch]);

    useEffect(() => {
        if (marketError === "Market mayhem history not found, create first.") {
            setInvestorBrokerSubmitted(false);
        }
    }, [marketError]);

    // Handle Refresh Button to reload portfolio value data
    const handleRefreshButton = () => {
        setLoading(true);
        dispatch(getMarketMayhem(gameId))
            .unwrap()
            .then(() => {
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }
    const handleSave = () => {
        setLoading(true)
        dispatch(CreateMarketMayhem({ gameId, stockIds: selectedCompanies, percentage: selectedPercentages })).unwrap().then((response) => {
            message.success('Market Mayhem create successfully');
            setShowAvg(true)
            dispatch(getMarketMayhem(gameId));
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            setSelectedCompanies([])
            setSelectedPercentages([])
            if (error?.error?.message === "The lengths of stock_ids and percentage must be the same.") {
                message.error('Please select both the company and percentage')
            } else if (error?.error?.message === '"percentage" does not contain 1 required value(s)') {
                message.error('Please select a percentage')
            } else {
                message.error(error?.error?.message)
            }
        });
    }

    const handleSaveInves = () => {
        if (selectedEntries.length === 0) {
            message.warning('Please add some selections before submitting.');
            return;
        }
        const stocksId = selectedEntries.map((entry) => ({
            stock_id: entry.company.stock_id,
            percentage: entry.percentage,
        }));

        setLoading(true)

        dispatch(RespondMarketMayhem({ marketMayhemId, stocks: stocksId })).then((response) => {
            setLoading(false);
            message.success("Market mayhem responded successfully.")
            if (roleIdStock === 3) {
                setInvestorBrokerSubmitted(true);
                setInvesBrokerResponse(false);
                dispatch(getMarketMayhem(gameId))
            } else {
                navigate('/stock-prices')
            }
        }).catch((error) => {
            setLoading(false);
            setSelectedCompanies([])
            setSelectedPercentages([])
            navigate('/stock-prices')
            message.error(error?.error?.message)
        });
    }

    const onNext = () => {
        if (!selectedInvesCompanies || !selectedInvesPercentages) {
            message.warning('Please select both a company and a percentage.');
            return;
        }

        setSelectedEntries([
            ...selectedEntries,
            {
                company: selectedInvesCompanies,
                percentage: selectedInvesPercentages,
            },
        ]);

        // Clear selections
        setSelectedInvesCompanies(null);
        setSelectedInvesPercentages(null);

        message.success('Selections added. Proceed to the next step.');
    }

    const handleEditVote = () => {
        if (selectedEntries.length === 0) {
            return;
        }

        const lastEntry = selectedEntries[selectedEntries.length - 1];
        setSelectedInvesCompanies(lastEntry.company);
        setSelectedInvesPercentages(lastEntry.percentage);
        setSelectedEntries((prev) => prev.slice(0, -1));
    }

    const handleAverage = () => {
        setLoading(true)
        dispatch(AveragreMarketMayhem(marketMayhemId)).unwrap().then((response) => {
            setLoading(false);
            message.success(response.message);
            navigate('/stock-prices')
        }).catch((error) => {
            setLoading(false);
            message.error(error?.error?.message)
        });
    }

    const isNextButtonVisible =
        getMarket?.data?.stock_ids.some(
            (stock: any) => !selectedEntries.some((entry) => entry.company.stock_id === stock.stock_id)
        ) &&
        getMarket?.data.percentage.some(
            (percentage: any) => !selectedEntries.some((entry) => entry.percentage === percentage)
        );
    const investorBroker = roleIdStock === 3 ? invesBrokerResponse : "";
    const mayhemCreated = !!getMarket?.data?.id;
    const submissionData =
        getMarket?.data?.responses ||
        getMarket?.data?.response ||
        getMarket?.data?.submitted_responses ||
        getMarket?.data?.submittedResponses ||
        getMarket?.data?.responded_players ||
        getMarket?.data?.respondedPlayers ||
        getMarket?.data?.market_mayhem_responses ||
        getMarket?.data?.marketMayhemResponses ||
        [];

    const normalizeId = (value: any) => {
        if (value === undefined || value === null) return null;
        return String(value);
    };

    const getSubmissionPlayerId = (entry: any) =>
        normalizeId(
            typeof entry === 'number' || typeof entry === 'string'
                ? entry
                :
                entry?.player_id ||
                entry?.playerId ||
                entry?.user_id ||
                entry?.userId ||
                entry?.submitted_by_player_id ||
                entry?.submittedByPlayerId ||
                entry?.responder_id ||
                entry?.responderId ||
                entry?.player?.player_id ||
                entry?.player?.id ||
                entry?.user?.user_id ||
                entry?.user?.id ||
                entry?.submitted_by?.player_id ||
                entry?.submitted_by?.id
        );

    const getSubmissionUsername = (entry: any) =>
        (entry?.username ||
            entry?.name ||
            entry?.player?.username ||
            entry?.player?.name ||
            entry?.user?.username ||
            entry?.user?.name ||
            entry?.submitted_by?.username ||
            entry?.submitted_by?.name ||
            ''
        ).toLowerCase();

    const submittedPlayerIds = new Set(
        Array.isArray(submissionData)
            ? submissionData
                .map((entry: any) => getSubmissionPlayerId(entry))
                .filter(Boolean)
            : []
    );

    const submittedUsernames = new Set(
        Array.isArray(submissionData)
            ? submissionData
                .map((entry: any) => getSubmissionUsername(entry))
                .filter(Boolean)
            : []
    );

    const submissionStatusPlayers = lobbyPlayers
        .filter((player: any) => player.role !== 1)
        .map((player: any) => ({
            ...player,
            roleLabel: player.role === 3 ? 'Broker & Investor' : player.role === 2 ? 'Investor' : 'Broker',
            hasSubmitted:
                submittedPlayerIds.has(normalizeId(player.player_id)) ||
                submittedPlayerIds.has(normalizeId(player.id)) ||
                submittedPlayerIds.has(normalizeId(player.user_id)) ||
                submittedUsernames.has((player.username || '').toLowerCase())
        }));
    const showSubmissionStatus =
        mayhemCreated &&
        !marketError &&
        marketError !== "Market mayhem history not found, create first.";
    const currentUserSubmitted =
        submittedPlayerIds.has(normalizeId(currentUser?.id)) ||
        submittedPlayerIds.has(normalizeId(currentUser?.user_id)) ||
        submittedUsernames.has((currentUser?.username || '').toLowerCase());

    useEffect(() => {
        if (!showSubmissionStatus) {
            setShowPlayersOnly(false);
        }
    }, [showSubmissionStatus]);

    useEffect(() => {
        if (percentageOpen || companyOpen) {
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
        } else {
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        }
        return () => {
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        }
    }, [percentageOpen, companyOpen]);

    return (
        <>
            <BackButton onClick={handleBackButton} back_class='market-mayhem-back' />
            <div className='account-heading'>
                <div className='purchase-btn-container'>
                    <img src={image.PURCHASE} className='purchase-btn' onClick={() => { window.open('https://joyjuncture.com', "__blank") }} />
                </div>
                <RefreshButton onClick={handleRefreshButton} />
            </div>
            <div className='market-mayhem-container'>
                <div className='main-heading font-bagel market-heading'>
                    <div>Market Mayhem</div>
                    <div className="get-help-addOn-hover" style={{ paddingTop: "7px", marginTop: "0px", paddingLeft: "3px" }}>
                        <div className="help-image-logo" > <IoMdInformationCircleOutline cursor='pointer' /></div>
                        <div className="get-help-add-on-hover-mayhem" style={{ textAlign: "start" }}>Create a voting list when a Market Mayhem card is triggered on the boards</div>
                    </div></div>
                {roleIdStock !== 2 && roleIdStock !== 3 &&
                    <div className='flex stockContainer' style={{ gap: "20px", marginTop: "20px" }}>
                        <div className='account-border'>
                            <div className='account-container flex market-container'>
                                {!loading ?
                                    <div className='market-dimension flex'>
                                        {marketError || marketError === "Market mayhem history not found, create first." ? (
                                            <>
                                                <div>
                                                    <div className='input-label'>Select Company</div>
                                                    <Select
                                                        value={selectedCompanies}
                                                        onChange={(values: number[]) => setSelectedCompanies(values)}
                                                        style={{ width: '100%' }}
                                                        dropdownStyle={{ backgroundColor: '#ffffff', zIndex: '10000' }}
                                                        popupClassName="select-dropdown-scroll-isolate"
                                                        mode="multiple"
                                                        placeholder='Select company'
                                                        showSearch={false}
                                                        onDropdownVisibleChange={setCompanyOpen}
                                                    >
                                                        {allStocks?.stocks_data?.map((stock: any) => (
                                                            <Option key={stock.id} value={stock.id} style={{ color: '#1C4384', fontWeight: '700' }}>
                                                                {stock.name}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>

                                                <div>
                                                    <SelectInput
                                                        label="Select Percentage"
                                                        value={selectedPercentages}
                                                        onChange={(values: any) => setSelectedPercentages(values)}
                                                        options={percentageMayhem.map((stock: any) => ({
                                                            label: stock.label,
                                                            value: stock.value
                                                        }))}
                                                        setMenuOpen={setPercentageOpen}
                                                        mode="multiple"
                                                        dropdownStyle={{ backgroundColor: '#ffffff', zIndex: '10000' }}
                                                        optionStyle={{ color: '#1C4384', fontWeight: '700' }}
                                                        placeholder='Select Percentage'
                                                    />
                                                </div>
                                            </>
                                        ) : (
                                            marketError !== null && (
                                                <div className='market-dimension flex' style={{ padding: "0" }}>
                                                    <div>
                                                        <Input
                                                            label='Companies'
                                                            placeholder='Enter Your Companies'
                                                            type="name"
                                                            id="name"
                                                            name="name"
                                                            value={getMarket?.data?.stock_ids.map((stock: any) => stock.name)}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div>
                                                        <Input
                                                            label='Percentages'
                                                            placeholder='Enter Your Percentage'
                                                            type="name"
                                                            id="name"
                                                            name="name"
                                                            value={getMarket?.data?.percentage.map((percent: any) => `${percent}%`)}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        )}
                                        {(!marketError && marketError !== "Market mayhem history not found, create first.") && showAvg && <Button onClick={handleAverage} buttonTitle='Average' />}
                                    </div> : <Loader white />}
                            </div>
                        </div>
                        {!loading && !showAvg && (selectedCompanies.length > 0 || selectedPercentages.length > 0) && <Button onClick={handleSave} buttonTitle={'Save'} width={'225px'} />}
                    </div>}
                {roleIdStock === 2 &&
                    <div className='flex stockContainer' style={{ gap: "20px", marginTop: "20px" }}>
                        <div className='account-border'>
                            <div className='account-container flex market-container-voting'>
                                {!loading ? <div className='market-dimension flex'>
                                    {selectedEntries.length >= 1 && <div className='back-btn voted-impact-text' onClick={handleEditVote}><IoChevronBackSharp size={18} /> <div className='voted-text'>YOUR VOTED IMPACT</div></div>}
                                    <div className='market_container'>
                                        {selectedEntries.map((entry, index) => (
                                            <div key={index} className="selected-item">
                                                <span>
                                                    {entry.company.name} : {entry.percentage}%
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                    {isNextButtonVisible && <div className='market-dimension flex' style={{ padding: "0" }}>
                                        <div>
                                            <div className="input-label">Select Company</div>
                                            <Select
                                                value={selectedInvesCompanies?.stock_id}
                                                onChange={(value) =>
                                                    setSelectedInvesCompanies(
                                                        getMarket.data.stock_ids.find((stock: any) => stock.stock_id === value)
                                                    )
                                                }
                                                style={{ width: '100%' }}
                                                placeholder="Select company"
                                                showSearch={false}
                                                popupClassName="select-dropdown-scroll-isolate"
                                                onDropdownVisibleChange={setCompanyOpen}
                                            >
                                                {getMarket.data.stock_ids
                                                    .filter(
                                                        (stock: any) =>
                                                            !selectedEntries.some(
                                                                (entry) => entry.company.stock_id === stock.stock_id
                                                            )
                                                    )
                                                    .map((stock: any) => (
                                                        <Option key={stock.stock_id} value={stock.stock_id} style={{ color: '#1C4384', fontWeight: '700' }}>
                                                            {stock.name}
                                                        </Option>
                                                    ))}
                                            </Select>
                                        </div>
                                        <div>
                                            <div className="input-label">Select Percentage</div>
                                            <Select
                                                value={selectedInvesPercentages}
                                                onChange={(value) => setSelectedInvesPercentages(value)}
                                                style={{ width: '100%' }}
                                                placeholder="Select percentage"
                                                dropdownStyle={{ backgroundColor: '#ffffff', zIndex: '10000' }}
                                                popupClassName="select-dropdown-scroll-isolate"
                                                onDropdownVisibleChange={setPercentageOpen}
                                            // optionStyle={{ color: '#1C4384', fontWeight: '700' }}

                                            >
                                                {getMarket.data.percentage
                                                    .filter(
                                                        (percentage: any) =>
                                                            !selectedEntries.some(
                                                                (entry) => entry.percentage === percentage
                                                            )
                                                    )
                                                    .map((percentage: any) => (
                                                        <Option key={percentage} value={percentage} style={{ color: '#1C4384', fontWeight: '700' }}>
                                                            {percentage}%
                                                        </Option>
                                                    ))}
                                            </Select>
                                        </div>
                                    </div>}
                                    {isNextButtonVisible && <Button onClick={onNext} buttonTitle='Next' />}
                                </div>
                                    : <Loader white />}
                            </div>
                        </div>
                        {!isNextButtonVisible && <Button onClick={handleSaveInves} buttonTitle={'Submit'} width={'225px'} />}
                    </div>}
                {roleIdStock === 3 && !investorBroker &&
                    <div className='flex stockContainer' style={{ gap: "20px", marginTop: "20px" }}>
                        <div className='account-border'>
                            <div className='account-container flex market-container'>
                                {!loading ?
                                    <div className='market-dimension flex'>
                                        {showPlayersOnly && showSubmissionStatus ? (
                                            <>
                                                <div className='submission-status-container'>
                                                    {submissionStatusPlayers.map((player: any) => (
                                                        <div className='submission-player-card' key={player.player_id || player.user_id}>
                                                            <img
                                                                src={getAvatarUrl(player.avatar_id)}
                                                                alt={player.username}
                                                                className='submission-player-avatar'
                                                                draggable="false"
                                                            />
                                                            <div className='submission-player-details'>
                                                                <div className='submission-status-name'>{player.username}</div>
                                                                <div className='submission-player-role'>{player.roleLabel}</div>
                                                            </div>
                                                            <div className={`submission-status-icon ${player.hasSubmitted ? 'submitted' : 'pending'}`}>
                                                                {player.hasSubmitted ? <IoCheckmark /> : <IoClose />}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                <Button onClick={() => setShowPlayersOnly(false)} buttonTitle='Back' />
                                            </>
                                        ) : (
                                            <>
                                                {marketError || marketError === "Market mayhem history not found, create first." ? (
                                                    <>
                                                        <div>
                                                            <div className='input-label'>Select Company</div>
                                                            <Select
                                                                value={selectedCompanies}
                                                                onChange={(values: number[]) => setSelectedCompanies(values)}
                                                                style={{ width: '100%' }}
                                                                dropdownStyle={{ backgroundColor: '#ffffff', zIndex: '10000' }}
                                                                popupClassName="select-dropdown-scroll-isolate"
                                                                mode="multiple"
                                                                placeholder='Select company'
                                                                showSearch={false}
                                                                onDropdownVisibleChange={setCompanyOpen}
                                                            >
                                                                {allStocks?.stocks_data?.map((stock: any) => (
                                                                    <Option key={stock.id} value={stock.id} style={{ color: '#1C4384', fontWeight: '700' }}>
                                                                        {stock.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>

                                                        <div>
                                                            <SelectInput
                                                                label="Select Percentage"
                                                                value={selectedPercentages}
                                                                onChange={(values: any) => setSelectedPercentages(values)}
                                                                options={percentageMayhem.map((stock: any) => ({
                                                                    label: stock.label,
                                                                    value: stock.value
                                                                }))}
                                                                setMenuOpen={setPercentageOpen}
                                                                mode="multiple"
                                                                dropdownStyle={{ backgroundColor: '#ffffff', zIndex: '10000' }}
                                                                optionStyle={{ color: '#1C4384', fontWeight: '700' }}
                                                                placeholder='Select Percentage'
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    marketError !== null && (
                                                        <div className='market-dimension flex' style={{ padding: "0" }}>
                                                            <div>
                                                                <Input
                                                                    label='Companies'
                                                                    placeholder='Enter Your Companies'
                                                                    type="name"
                                                                    id="name"
                                                                    name="name"
                                                                    value={getMarket?.data?.stock_ids.map((stock: any) => stock.name)}
                                                                    disabled
                                                                />
                                                            </div>
                                                            <div>
                                                                <Input
                                                                    label='Percentages'
                                                                    placeholder='Enter Your Percentage'
                                                                    type="name"
                                                                    id="name"
                                                                    name="name"
                                                                    value={getMarket?.data?.percentage.map((percent: any) => `${percent}%`)}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                                {roleIdStock === 3 && (!marketError && marketError !== "Market mayhem history not found, create first.") && !investorBrokerSubmitted && !currentUserSubmitted && <Button onClick={() => { setInvesBrokerResponse(true) }} buttonTitle='Your Response' />}
                                                {(!marketError && marketError !== "Market mayhem history not found, create first.") && <Button onClick={handleAverage} buttonTitle='Average' />}
                                                {showSubmissionStatus && submissionStatusPlayers.length > 0 && (
                                                    <Button onClick={() => setShowPlayersOnly(true)} buttonTitle='Player Submission Status' />
                                                )}
                                            </>
                                        )}
                                    </div> : <Loader white />}
                            </div>
                        </div>
                        {!loading && !showAvg && (selectedCompanies.length > 0 || selectedPercentages.length > 0) && <Button onClick={handleSave} buttonTitle={'Save'} width={'225px'} />}
                    </div>}
                {roleIdStock === 3 && investorBroker &&
                    <div className='flex stockContainer' style={{ gap: "20px", marginTop: "20px" }}>
                        <div className='account-border'>
                            <div className='account-container flex market-container-voting'>
                                {!loading ? <div className='market-dimension flex'>
                                    {selectedEntries.length >= 1 && <div className='back-btn voted-impact-text' onClick={handleEditVote}><IoChevronBackSharp size={18} /> <div className='voted-text'>YOUR VOTED IMPACT</div></div>}
                                    <div className='market_container'>
                                        {selectedEntries.map((entry, index) => (
                                            <div key={index} className="selected-item">
                                                <span>
                                                    {entry.company.name} : {entry.percentage}%
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                    {isNextButtonVisible && <div className='market-dimension flex' style={{ padding: "0" }}>
                                        {selectedEntries.length < 1 && <div className='back-btn' onClick={() => { setInvesBrokerResponse(false) }}><IoChevronBackSharp size={18} /></div>}
                                        <div>
                                            <div className="input-label">Select Company</div>
                                            <Select
                                                value={selectedInvesCompanies?.stock_id}
                                                onChange={(value) =>
                                                    setSelectedInvesCompanies(
                                                        getMarket.data.stock_ids.find((stock: any) => stock.stock_id === value)
                                                    )
                                                }
                                                style={{ width: '100%' }}
                                                placeholder="Select company"
                                                showSearch={false}
                                                popupClassName="select-dropdown-scroll-isolate"
                                                onDropdownVisibleChange={setCompanyOpen}
                                            >
                                                {getMarket.data.stock_ids
                                                    .filter(
                                                        (stock: any) =>
                                                            !selectedEntries.some(
                                                                (entry) => entry.company.stock_id === stock.stock_id
                                                            )
                                                    )
                                                    .map((stock: any) => (
                                                        <Option key={stock.stock_id} value={stock.stock_id} style={{ color: '#1C4384', fontWeight: '700' }}>
                                                            {stock.name}
                                                        </Option>
                                                    ))}
                                            </Select>
                                        </div>
                                        <div>
                                            <div className="input-label">Select Percentage</div>
                                            <Select
                                                value={selectedInvesPercentages}
                                                onChange={(value) => setSelectedInvesPercentages(value)}
                                                style={{ width: '100%' }}
                                                placeholder="Select percentage"
                                                dropdownStyle={{ backgroundColor: '#ffffff', zIndex: '10000' }}
                                                popupClassName="select-dropdown-scroll-isolate"
                                                onDropdownVisibleChange={setPercentageOpen}
                                            // optionStyle={{ color: '#1C4384', fontWeight: '700' }}

                                            >
                                                {getMarket.data.percentage
                                                    .filter(
                                                        (percentage: any) =>
                                                            !selectedEntries.some(
                                                                (entry) => entry.percentage === percentage
                                                            )
                                                    )
                                                    .map((percentage: any) => (
                                                        <Option key={percentage} value={percentage} style={{ color: '#1C4384', fontWeight: '700' }}>
                                                            {percentage}%
                                                        </Option>
                                                    ))}
                                            </Select>
                                        </div>
                                    </div>}
                                    {isNextButtonVisible && <Button onClick={onNext} buttonTitle='Next' />}
                                </div>
                                    : <Loader white />}
                            </div>
                        </div>
                        {!isNextButtonVisible && <Button onClick={handleSaveInves} buttonTitle={'Submit'} width={'225px'} />}
                    </div>}


            </div >
        </>

    )
}

export default MarketMayhemScreen
